<agr-page-toolbar
  [isEmpty]="(cycle$ | async)?.arrivals.length === 0"
  [emptyTitle]="'arrival.no-arrivals-title' | translate"
  [emptyDescription]="'arrival.no-arrivals-description' | translate"
  emptyImage="assets/images/arrival.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDialog()"
  data-test="arrival-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && cycle$ | async as cycle">
    <mat-nav-list role="list" *ngIf="cycle?.arrivals?.length" class="arrival-overview__list">
      <a
        mat-list-item
        *ngFor="let arrival of sort(cycle.arrivals)"
        role="listitem"
        class="arrival-item"
        [attr.data-test]="'arrival-overview__item_' + arrival.id"
        (click)="openArrivalEdit(arrival.id)"
      >
        <mat-icon
          matListItemIcon
          matListItemAvatar
          class="list-avatar"
          svgIcon="mdi-inbox-arrow-down"
        ></mat-icon>
        <div matListItemTitle>{{ arrival.arrivalDate | date }}</div>
        <div matListItemLine class="text--gray">
          {{ arrival.numberOfAnimals | agrNumber }} {{ arrival.gender | translate | lowercase }} ({{
            arrival.breed?.name
          }})
        </div>
        <div matListItemLine class="text--gray">{{ arrival?.hatchery?.name }}</div>
        <button
          matListItemMeta
          mat-icon-button
          (click)="delete($event, arrival)"
          data-test="arrival-overview__delete-item"
        >
          <mat-icon iconPositionEnd>delete</mat-icon>
        </button>
      </a>
      <mat-divider *ngIf="cycle.arrivals.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
